import { useState } from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Pagination,
  Box,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DeleteIcon from '@mui/icons-material/Delete';
import { useIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export default function CustomTrainingsBlock({ trainings, onInfoClick, onDeleteClick }) {
  const intl = useIntl();
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const displayedTrainings = trainings.slice(startIndex, endIndex);

  return (
    <Box>
      {displayedTrainings.map((training) => (
        <Card key={training.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">{training.name}</Typography>
            <Typography variant="body2" color="textSecondary">
              {training.description}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              <FormattedMessage id="customTrainings.label.createdAt" defaultMessage="Created At" />:{' '}
              {new Date(training.createdAt).toLocaleString()}
            </Typography>
          </CardContent>
          <CardActions>
            <IconButton
              aria-label={intl.formatMessage({ id: 'customTrainings.tooltip.info', defaultMessage: 'View Info' })}
              onClick={() => onInfoClick(training)}
            >
              <InfoIcon color="primary" />
            </IconButton>
            <IconButton
              aria-label={intl.formatMessage({ id: 'customTrainings.tooltip.delete', defaultMessage: 'Delete Training' })}
              onClick={() => onDeleteClick(training)}
            >
              <DeleteIcon color="error" />
            </IconButton>
          </CardActions>
        </Card>
      ))}
      <Pagination
        count={Math.ceil(trainings.length / ITEMS_PER_PAGE)}
        page={currentPage}
        onChange={handlePageChange}
        sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}
      />
    </Box>
  );
}

CustomTrainingsBlock.propTypes = {
  trainings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
    })
  ).isRequired,
  onInfoClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
};
